<template>
  <el-skeleton
    animated
    :count="count"
    aria-hidden="true"
  >
    <template #template>
      <slot />
    </template>
  </el-skeleton>
</template>

<script setup>
defineOptions({ name: 'ListSkeleton' });

defineProps({
  count: {
    type: Number,
    default: 8,
  },
});
</script>
